export const GET_BANNERS = 'banners/allBanners/get';
export const GET_BANNER_BY_ID = 'banners/bannerById/get';